module.exports = __webpack_public_path__ + "static/media/Delete.179f357f.svg";